export default __webpack_public_path__ + "static/media/linkedin.ac27a570.svg";